var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.blogList.length > 3
    ? _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { staticClass: "blog-container", attrs: { span: 24 } },
                    [
                      _c(
                        "div",
                        { staticClass: "blog-header" },
                        [
                          _c("h2", { staticClass: "blog-title-main" }, [
                            _vm._v("Latest Posts")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary view-all-btn",
                              on: { click: _vm.viewAllPosts }
                            },
                            [_vm._v("View All")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.blogList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "blog-list" },
                            _vm._l(_vm.blogList.slice(0, 8), function(blog) {
                              return _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "blog-card",
                                    on: {
                                      click: function($event) {
                                        return _vm.redirectToBlog(blog.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "blog-image",
                                      attrs: {
                                        src: blog.imageUrl,
                                        alt: "Blog post image"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "blog-content" }, [
                                      _c("h1", { staticClass: "blog-title" }, [
                                        _vm._v(_vm._s(blog.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "blog-description",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.truncateHtml(blog.content)
                                          )
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "blog-date" }, [
                                      _c(
                                        "time",
                                        {
                                          attrs: { datetime: blog.publishedOn }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(blog.publishedOn)
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            }),
                            0
                          )
                        : _c("div", { staticClass: "blog-list-empty" }, [
                            _c("span", [_vm._v("No blogs found")])
                          ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aee06292", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee06292","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/blogWidgetView/blogWidgetLayout.vue
// module id = null
// module chunks = 